var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"activity"},[_c('div',{staticClass:"link"},[_c('div',{staticClass:"enter"},[_c('img',{attrs:{"src":require("@/assets/activity/enter.png"),"alt":""},on:{"click":_vm.intetClick}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }